import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { IqacContentRoutingModule } from './iqac-content-routing.module';
import { IqaccontentListComponent } from './iqaccontent-list/iqaccontent-list.component';
import { IqaccontentCreateComponent } from './iqaccontent-create/iqaccontent-create.component';

@NgModule({
  declarations: [IqaccontentListComponent, IqaccontentCreateComponent],
  imports: [
    CommonModule,
    IqacContentRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class IqacContentModule { }
